 <!-- 订单应付详情 -->
<template>
  <div id="PayableDetails">
    <div class="title">财务应收</div>
    <div class="receivable"></div>
    <div class="payable"></div>
    <div class="title">财务应付</div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped lang="less">
#PayableDetails {
  .title {
    background: #eee;
    padding: 10px 20px;
    color: blue;
  }
  .receivable,
  .payable {
    border: 1px solid rgba(0, 0, 0, 0.6);
  }
}
</style>
